import { useEffect } from 'react';

const DEFAULT = {
  title: 'Hallie · Eureka1 — Operations & Systems Specialist',
  description:
    'Hallie helps service-based businesses streamline operations, improve customer experiences, and build reliable systems that support sustainable growth. Operations support, website design, SEO, social media.',
  image: 'https://customer-assets.emergentagent.com/job_ops-excellence-28/artifacts/euqbi532_20260520_010613-IMG_STYLE.jpg',
  url: 'https://halliev.com',
};

function setMeta(attr, key, value) {
  if (!value) return;
  let el = document.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute('content', value);
}

function setLink(rel, value) {
  if (!value) return;
  let el = document.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement('link');
    el.setAttribute('rel', rel);
    document.head.appendChild(el);
  }
  el.setAttribute('href', value);
}

function setSchema(id, data) {
  let el = document.getElementById(id);
  if (!el) {
    el = document.createElement('script');
    el.type = 'application/ld+json';
    el.id = id;
    document.head.appendChild(el);
  }
  el.textContent = JSON.stringify(data);
}

/**
 * useSEO — page-level meta + Open Graph + Twitter + JSON-LD schema.
 */
export default function useSEO({ title, description, image, path, schema } = {}) {
  useEffect(() => {
    const fullTitle = title ? `${title} · Hallie · Eureka1` : DEFAULT.title;
    const desc = description || DEFAULT.description;
    const img = image || DEFAULT.image;
    const url = `${DEFAULT.url}${path || ''}`;

    document.title = fullTitle;
    setMeta('name', 'description', desc);
    setMeta('property', 'og:title', fullTitle);
    setMeta('property', 'og:description', desc);
    setMeta('property', 'og:image', img);
    setMeta('property', 'og:url', url);
    setMeta('property', 'og:type', 'website');
    setMeta('property', 'og:site_name', 'Hallie · Eureka1');
    setMeta('name', 'twitter:card', 'summary_large_image');
    setMeta('name', 'twitter:title', fullTitle);
    setMeta('name', 'twitter:description', desc);
    setMeta('name', 'twitter:image', img);
    setLink('canonical', url);

    if (schema) {
      const id = `schema-${(path || 'home').replace(/[^a-z0-9]/gi, '-')}`;
      setSchema(id, schema);
    }
  }, [title, description, image, path, schema]);
}
